import { useCourseSelector } from 'modules/courses/components/CourseSelector';

import { useSubjectItemsSelector } from '../../components/SubjectItemsSelector';

export default function useImportSubjectItemsFromCourse({
  courseId,
  excludeCurrentCourse = false,
  items,
  loading,
  submitting,
  title,
  confirmButtonTitle,
  onConfirmSelection,
} = {}) {
  const { selectedCourse, props: courseSelectorProps } = useCourseSelector({
    excludedCourses: excludeCurrentCourse ? [courseId] : [],
  });

  const subjectItemsSelectorProps = useSubjectItemsSelector({
    items,
    loading,
    title,
    submitting,
    confirmButtonTitle,
    onConfirmSelection,
  });

  return {
    selectedCourse,
    courseSelectorProps,
    subjectItemsSelectorProps,
  };
}
